export const getAbValueFromCookie = (): number => {
    if (typeof document === 'undefined') return 0
    const cookies = document.cookie.split('; ')
    const abCookie = cookies.find(cookie => cookie.startsWith('ab_value='))
    return abCookie ? parseInt(abCookie.split('=')[1]) : 0
}
